import api from './api';

// Async job pattern: POST creates a job, the server processes it (long-timeout worker), the client
// polls the job by id, then deletes it once the reply is shown.
const connectorAssistantService = {
  // returns { jobId }
  start: (messages, connectorContext) =>
    api.post('/admin/connectorassistant', { messages, connectorContext }),
  // returns { status: 'pending'|'done'|'error', reply, error }
  result: (jobId) => api.get(`/admin/connectorassistant/${jobId}`),
  remove: (jobId) => api.delete(`/admin/connectorassistant/${jobId}`),
};

export default connectorAssistantService;
